import { render, staticRenderFns } from "./BreakButton.vue?vue&type=template&id=2ddc79e4&scoped=true&"
import script from "./BreakButton.vue?vue&type=script&lang=js&"
export * from "./BreakButton.vue?vue&type=script&lang=js&"
import style0 from "./BreakButton.vue?vue&type=style&index=0&id=2ddc79e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc79e4",
  null
  
)

export default component.exports